"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDataUnit extends new_item_1.default {
    constructor(newDataUnit) {
        super();
        this.dataType = newDataUnit.dataType;
        this.unitCategory = newDataUnit.unitCategory;
        this.name = newDataUnit.name;
        this.unitType = newDataUnit.unitType;
        this.metaData = newDataUnit.metaData;
        this._permission = newDataUnit._permission;
        this.global = newDataUnit.global;
    }
}
exports.default = NewDataUnit;
//# sourceMappingURL=new-dataUnit.js.map